// extracted by mini-css-extract-plugin
export default {"wrapper":"GjW_huIDWA527_QJM4uX","small":"u73O_OkMJMlZ4mUYHbmc"};